<template>
  <div v-if="this.hasLandowner(rowData)">

    <table class="el-table">
      <thead>
        <tr>
          <th><h3>Insurance Policy Details</h3></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tfoot>
      </tfoot>
      <tbody>
        <tr>
          <td>Policy #</td>
          <td>{{localSite.policyNo}}</td>
          <td><b>{{formatNumber(localSite.landValue)}}</b> Insured Value</td>
        </tr>
        <tr>
          <td>Coverage Started</td>
          <td>{{formatDate(localSite.landStarted)}}</td>
          <td><b>{{formatNumber(localSite.landValue)}}</b> {{localSite.landPaymentFrequency}} Renwal</td>
        </tr>
        <tr>
          <td>Policy Expiry</td>
          <td><strong>{{formatDate(localSite.landExpiry)}}</strong> <i>({{formatFriendlyDate(localSite.landExpiry)}})</i></td>
          <td>
            <span v-if="localSite.term">
              <strong>{{localSite.term}}</strong>
               renewed time{{localSite.term > 1 ? 's' : ''}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      localSite: this.rowData
    }
  }
}
</script>



// WEBPACK FOOTER //
// InsuranceRenewal.vue?785a62f2